export default "__VITE_ASSET__e8663649__"